/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 提示枚举
 */
export enum SimpleModeTipE {
    /**
     * 极简/标准模式切换Tip
     */
    SimpleModeSwitch = 1,
    /**
     * 智能助手Tip
     */
    SmartAssistant = 2
}

/**
 * 提示数量枚举
 */
export enum SimpleModeTipNumE {
    /**
     * 标准模式1条提示
     */
    Standard = 1,
    /**
     * 极简模式2条提示
     */
    Simple = 2
}

/**
 * 极简/标准模式切换Tip背景
 */
export const SIMPLE_SWITCH_BG_URL = 'url("/assets/images/simple-mode-tip-switch.png")';

/**
 * 智能助手Tip背景
 */
export const SMART_ASSISTANT_BG_URL = 'url("/assets/images/simple-mode-tip-assistant.png")';
